import LegalPageLayout from "@/components/LegalPageLayout";

const H = ({ children }) => (
  <h2 className="mt-8 font-serif text-2xl text-navy">{children}</h2>
);

export default function Terms() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Terms & Conditions"
      lastUpdated="February 2026"
      testId="terms-page"
    >
      <p>
        These Terms & Conditions govern your use of WillSeva. By using our platform,
        you agree to be bound by them. Please read carefully.
      </p>

      <H>1. User Responsibility</H>
      <p>
        You are solely responsible for the correctness and completeness of all
        information submitted through the platform, including but not limited to:
      </p>
      <ul className="ml-5 list-disc space-y-1">
        <li>Personal details and identity information</li>
        <li>Beneficiary names, relationships and shares</li>
        <li>Asset descriptions, ownership and approximate values</li>
        <li>Execution of the will — signing, witnessing and storage in accordance with applicable law</li>
      </ul>
      <p>
        Errors, omissions, or non-compliance with execution formalities are your
        responsibility and may affect the legal validity of the document.
      </p>

      <H>2. Platform Positioning</H>
      <p>
        WillSeva is a document preparation and drafting assistance platform. It
        provides a professionally structured will template aligned with the Indian
        Succession Act, 1925, using a deterministic drafting engine. Lawyer review
        is optional and available only when separately purchased.
      </p>

      <H>3. No Guarantee</H>
      <p>
        WillSeva does <strong>not</strong> guarantee:
      </p>
      <ul className="ml-5 list-disc space-y-1">
        <li>Probate approval or any specific court outcome</li>
        <li>Acceptance of the will in any litigation or dispute</li>
        <li>Tax outcomes or estate-planning efficiency</li>
        <li>Dispute-free inheritance or family harmony</li>
      </ul>

      <H>4. Limitation of Liability</H>
      <p>
        To the maximum extent permitted by law, WillSeva, its founders, employees,
        associates, lawyers, contractors and affiliates shall not be liable for any
        direct, indirect, incidental, consequential or special damages including but
        not limited to:
      </p>
      <ul className="ml-5 list-disc space-y-1">
        <li>Inheritance disputes among family members</li>
        <li>Assets omitted by the user</li>
        <li>Errors in user-supplied information</li>
        <li>Probate or registration delays</li>
        <li>Execution defects (signing, witnessing, storage)</li>
        <li>Tax consequences</li>
        <li>Any indirect or consequential losses</li>
      </ul>

      <H>5. Liability Cap</H>
      <p>
        The maximum aggregate liability of WillSeva in connection with the platform
        or any service shall not exceed the amount actually paid by the user for the
        specific service giving rise to the claim.
      </p>

      <H>6. Personal Law Disclaimer</H>
      <p>
        Inheritance laws in India vary by religion, domicile, citizenship and
        applicable personal law. The platform provides a template aligned with the
        Indian Succession Act, 1925; users with complex personal-law considerations
        are advised to consult independent legal counsel.
      </p>

      <H>7. Independent Legal Advice</H>
      <p>
        Users with foreign assets, business interests, trusts, disputed property,
        contested family arrangements, or otherwise complex estates are strongly
        encouraged to seek independent legal counsel before relying on documents
        generated through the platform.
      </p>

      <H>8. Lawyer Review Scope</H>
      <p>
        When purchased, the Lawyer Review service is limited to the specific
        consultation and review scope agreed at the time of purchase. No ongoing
        attorney-client relationship, retainer or representation is created unless
        separately agreed to in writing.
      </p>

      <H>9. Refunds</H>
      <p>
        Please refer to our{" "}
        <a className="font-medium text-navy underline" href="/refund-policy">
          Refund Policy
        </a>
        . All payments are strictly non-refundable.
      </p>

      <H>10. Governing Law & Jurisdiction</H>
      <p>
        These Terms shall be governed by the laws of India. The courts of Mumbai
        shall have exclusive jurisdiction over any dispute arising out of or
        relating to these Terms or your use of the platform.
      </p>
    </LegalPageLayout>
  );
}
